import * as yup from "yup"
export const studentTaskSchema = yup.object().shape({
  task_url: yup
    .string()
    .url("this feild should be URL")
    .required("this feild required"),
})
